module.exports = __webpack_public_path__ + "media/images/forest_wide_main-ba44521504e8698acbfdf3db2abfd087.png";